import React, { Component } from 'react';
import './FAQ.css';

import config1 from './.image/config1.jpg';
import config2 from './.image/config2.jpg';

export class FAQ extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <div className="faq">
                <table style={{width:"100%"}}>
                    <thead>
                        <tr className="faq-table-row">
                            <th>問題標題</th>
                            <th>問題回應內容</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="faq-table-row">
                            <td>1.建物細緻度等級(Level of detail)如何定義?</td>
                            <td>本系統納入近似化建物模型及精緻建物模型，屬積木式模型(Block Model)，建物細緻度等級(Level of detail)係參照OGC CityGML 定義內容，<br />
                                LOD詳細定義請參考OGC CityGML 文件(網址：<a href="https://www.ogc.org/standards/citygml" target="_blank" rel="noopener noreferrer">https://www.ogc.org/standards/citygml</a>)。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>2.如何清除定位結果或量距功能之距離標註? </td>
                            <td>請點選量距功能 下方「清除結果」功能，刪除距離量測紀錄。</td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>3.如何操作旋轉3D圖臺的視角等? </td>
                            <td> 1. 使用滑鼠、右上角三維視覺化操作盤以及鍵盤WASD按鍵等3種方式，提供使用者操作圖臺檢視視角的俯、仰、旋轉、平移與縮放等行為，操作說明可參考圖臺右上方「功能說明」。<br />
                                2. 利用鍵盤快捷鍵(+、-、n、r、u、shift、ctrl)搭配滑鼠移動視角<br />
                                3. 圖臺預設的視角旋轉以使用者自身為軸心，若想指定某點位置為軸心，請點選欲環視之目標物，接著點選右下方「定點環視」功能，此時即可針對目標物進行旋轉環視；<br />
                                再次點擊定點環視時，即可取消環視功能回復標準之瀏覽模式。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>4.請問如何使用定位功能? </td>
                            <td>由首頁「進入地圖」進入圖臺，點選圖臺頁面下方「工具列」，選擇「定位功能」，即自動開啟操作介面，<br />
                                其中包括門牌定位、地號定位、坐標定位，使用者可選擇定位方式進而輸入相應條件進行定位查詢。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>5.如何清除瀏覽器暫存資料?</td>
                            <td> 1. 使用快捷鍵︰，利用快捷鍵[Ctrl]+[Shift]+[Del]，開啟「瀏覽器快取清除選單」後，將下列兩種資料選取並刪除：<br />
                                (1) cache資料 如「網際網路暫存檔」、「快取圖片和檔案」等。<br />
                                (2) cookie資料。<br />
                                2. FireFox、Chrome、Edge及Safari暫存資料清除，請參考下列圖示操作(可能因瀏覽器版本不同，導致圖示內容位置略有差異)：<br />
                                (1) FireFox :頁面右側「工具」-「選項」-「隱私權及安全性」-「瀏覽紀錄」項下點選「清除瀏覽紀錄」，勾選「cookie」及「快取」，按「立即清除」即可。<br />
                                <img src={config1} alt="config1" />
                                <img src={config2} alt="config2" /><br />
                                Chrome : 「設定」-「顯示進階設定...」 -「隱私權及安全性」-「清除瀏覽資料...」-勾選 「Cookies...」及「快取圖片和檔案」，按「清除資料」 即可。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>6.空間距離與地表距離測量，有何差異? </td>
                            <td>空間距離為三維空間兩點之間的最短直線距離。地表距離則為兩地表上的空間點之間沿地形起伏之最短距離。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>7.三維地形資料為何?</td>
                            <td>本系統展示及發布三維地形資料為20公尺網格間距成果。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>8.請問我是否可以自己選擇想套疊的圖資呢?</td>
                            <td>1. 由首頁「進入地圖」進入圖臺，使用右方「圖資庫」功能，圖臺即自動開啟圖層設定操作介面，使用者可依需求點選底圖及選取欲套疊之二維或三維圖層(可複選)。<br/>
                                2. 已選取的套疊圖層將列表於圖資庫按鈕下方之「已選圖層區」中，提供透明度調整、定位至圖層位置之功能。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>9.地圖上距離量測的準確度如何?</td>
                            <td>由於各圖資坐標不同，經過坐標轉換及投影系統等因素，將產生地圖量測距離與實地真實測量結果之間的誤差。因此距離量測的數值僅供使用者參考。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>10.二維圖資料來源</td>
                            <td>二維圖資係由南投縣府各局處蒐整而來之圖資。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>11.為什麼圖資顯示速度這麼慢?</td>
                            <td>1. 圖資顯示速度受電腦顯圖能力影像，如果想要能順暢的瀏覽三維圖資，建議提升個人瀏覽設備及網路環境。<br/>
                                2. 本系統建議用eChrome、FireFox、Safari或Edge等瀏覽器。<br/>
                                3. 瀏覽器的Proxy與快取的空間大小也會影響圖資顯示速度，建議關閉瀏覽器的Proxy的機制與減少快取的空間大小(建議用小於256MB)，並清除瀏覽器暫存區資料，以提升您的電腦反應速度。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>12.地表距離測量如何計算長度?</td>
                            <td>地表距離為兩地表上的空間點之間沿地形起伏之最短距離。<br/>
                                其計算原理係將兩空間點間之地形起伏（10米DTM）的距離連線切分為100個間隔數，計算各間隔點間直線距離加總，得地表距離量測成果
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>13.三維建物模型資料來源?</td>
                            <td>本系統介接國土測繪中心圖資，提供即時三維建物模型圖資展示。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>14.請問我如何得知使用圖資基礎資訊?</td>
                            <td>本系統首頁，點選「圖資使用說明」功能，可看到各項圖資內容說明。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>15.請問3DTILES是什麼?</td>
                            <td>本系統發布3DTILES服務為符合OGC國際標準之3D網路圖資服務。
                            </td>
                        </tr>
                        <tr className="faq-table-row">
                            <td>16.請問I3S是什麼?</td>
                            <td>本系統發布I3S服務為符合OGC國際標準之3D網路圖資服務。
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}